import { Flow_0_0_2 } from '@flexus/core';

export const BUI_35: Flow_0_0_2 = {
	id: '35',
	name: 'work_paused',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: 'Wait for SP to resume work'
		}
	},
	startNode: '',
	nodes: {}
};
